import React, { FC, useContext, useEffect, useState } from 'react'
import './PasswordForm.scss'
import {
  ALIGN_BUTTONS_AND_LINKS,
  FORGOT_LINKS_LAYOUT,
  SHOW_FORGOT_PASSWORD_LINK,
} from '~utils/featureFlags'
import { IUserContextType, UserContext } from '~utils/context/UserContext'
import { Button, Form, FormInput, Icon, Link } from '@connectcore/connect-components-react'
import { useHistory } from 'react-router-dom'
import { LOGIN_FAILURE_SCD_ERROR, LOGIN_FORM_HEADER } from '~utils/constants'
import { CallbackType } from '@forgerock/javascript-sdk'

const PasswordForm: FC = () => {
  const [data, setData] = useState({ password: null })
  const [showPass, setShowPass] = useState(false)
  const [apiError, setApiError] = useState(false)
  const { step, nextStep, showErr, storeToken, setStep, setIsLoading } = useContext(
    UserContext
  ) as IUserContextType
  const history = useHistory()

  const linksStyle = SHOW_FORGOT_PASSWORD_LINK ? FORGOT_LINKS_LAYOUT : ''

  let passwordCallBackFn
  if (step?.getCallbacksOfType(CallbackType.PasswordCallback)?.length > 0)
    passwordCallBackFn = step?.getCallbackOfType(CallbackType.PasswordCallback)

  useEffect(() => {
    setApiError(showErr)
  }, [showErr])
  const submitPassword = () => {
    passwordCallBackFn?.setInputValue(data.password)
    nextStep(step)
  }

  return (
    <Form
      className="PasswordForm"
      data-testid="PasswordForm"
      onChange={e => {
        setData({ ...data, ...e })
        setApiError(false)
      }}
      onSubmit={() => submitPassword()}
      key="PasswordForm"
    >
      <h2 className="fw-bold">{LOGIN_FORM_HEADER}</h2>

      <FormInput
        className="my-5"
        name="password"
        required={true}
        label="Password"
        iconOverlay
        type={showPass ? 'text' : 'password'}
        appendWith={
          <Icon
            className="p-0"
            name={showPass ? 'hide' : 'view-watchlist'}
            actionable
            onClick={() => {
              setShowPass(!showPass)
            }}
            aria-label={showPass ? 'Hide password' : 'Show password'}
          />
        }
      />

      {apiError && (
        <p className="invalid-feedback" role="alert">
          {LOGIN_FAILURE_SCD_ERROR}
        </p>
      )}

      <div className="d-flex flex-column">
        <Button kind="primary" className={`my-3 align-${ALIGN_BUTTONS_AND_LINKS}`}>
          Login
        </Button>

        <div className="forgot-links">
          {SHOW_FORGOT_PASSWORD_LINK && (
            <Link
              href="#"
              className={`my-3 ${linksStyle}`}
              onClick={eve => {
                eve.preventDefault()
                setIsLoading(true)
                setStep(undefined)
                history.push({
                  pathname: '/forgotPassword',
                  state: { storeToken: storeToken },
                })
              }}
            >
              Forgot Password
            </Link>
          )}
          <br />
        </div>
      </div>
    </Form>
  )
}

export default PasswordForm
